export const getLitrosDaLinha = (item, isSyndicProfile) => {
  if (!item) return 0

  if (isSyndicProfile) {
    const m3DaLinha = Number(item.NR_QUANTIDADE_LITROSMC || 0)
    if (Number.isFinite(m3DaLinha) && m3DaLinha > 0) {
      return m3DaLinha * 1000
    }

    const litrosSyndic = Number(item.NR_LITROS_CONSUMO || 0)
    if (Number.isFinite(litrosSyndic) && litrosSyndic > 0) {
      return litrosSyndic
    }

    const litrosDelta =
      Number(item.NR_DIFERENCA_CONSUMO || 0) *
      Number(item.VR_LITROS_POR_PULSO || 0)
    return Number.isFinite(litrosDelta) && litrosDelta >= 0 ? litrosDelta : 0
  }

  const litrosAdmin =
    Number(item.NR_DIFERENCA_CONSUMO || 0) *
    Number(item.VR_LITROS_POR_PULSO || 0)
  if (Number.isFinite(litrosAdmin) && litrosAdmin > 0) {
    return litrosAdmin
  }

  const litrosFallback = Number(item.NR_LITROS_CONSUMO || 0)
  if (Number.isFinite(litrosFallback) && litrosFallback > 0) {
    return litrosFallback
  }

  return 0
}

export const getConsumoDaLinha = item => {
  if (!item) return 0

  const consumo =
    Number(item.NR_DIFERENCA_CONSUMO || 0) *
    Number(item.VR_LITROS_POR_PULSO || 0)

  return Number.isFinite(consumo) ? consumo : 0
}

export const getM3DaLinha = (item, isSyndicProfile) => {
  if (!item) return 0

  const m3 = Number(item.NR_QUANTIDADE_LITROSMC)
  if (Number.isFinite(m3) && m3 > 0) {
    return m3
  }

  return getLitrosDaLinha(item, isSyndicProfile) / 1000
}

/** Relojoaria + (pulsos × litros por pulso). Unidades = m³×1000 no mostrador. */
export const getLeituraAtualDaLinha = item => {
  if (!item) return 0

  const relojoaria = parseInt(item.RELOJOARIA || 0, 10)
  const pulso = Number(item.VR_LEITURA_LITROS ?? item.NR_PULSO ?? 0)
  const litrosPorPulso = Number(item.VR_LITROS_POR_PULSO || 0)
  const incremento = Math.round(pulso * litrosPorPulso)

  return (
    (Number.isFinite(relojoaria) ? relojoaria : 0) +
    (Number.isFinite(incremento) ? incremento : 0)
  )
}

/**
 * Consumo do período por medidor: última leitura − primeira no período.
 * Retorna total nas mesmas unidades de NR_LEITURA_ATUAL (m³ × 1000).
 */
export const getConsumoPeriodoTotal = registros => {
  if (!Array.isArray(registros) || registros.length === 0) return 0

  const leituraPorMedidor = {}

  registros.forEach(item => {
    const medidorKey = `${item.NR_HIDROMETRO_IMOVEL}-${
      item.DS_COMPLEMENTO_IMOVEL || ""
    }`
    const dtLeitura = new Date(item.DT_LEITURA).getTime()
    const leituraAtual = Number(
      item.NR_LEITURA_ATUAL ?? getLeituraAtualDaLinha(item),
    )
    if (!Number.isFinite(dtLeitura) || !Number.isFinite(leituraAtual)) return

    if (!leituraPorMedidor[medidorKey]) {
      leituraPorMedidor[medidorKey] = {
        minDate: dtLeitura,
        maxDate: dtLeitura,
        minLeitura: leituraAtual,
        maxLeitura: leituraAtual,
      }
      return
    }

    if (dtLeitura < leituraPorMedidor[medidorKey].minDate) {
      leituraPorMedidor[medidorKey].minDate = dtLeitura
      leituraPorMedidor[medidorKey].minLeitura = leituraAtual
    }

    if (dtLeitura > leituraPorMedidor[medidorKey].maxDate) {
      leituraPorMedidor[medidorKey].maxDate = dtLeitura
      leituraPorMedidor[medidorKey].maxLeitura = leituraAtual
    }
  })

  return Object.values(leituraPorMedidor).reduce((acc, item) => {
    const consumoMedidor = Math.max(0, item.maxLeitura - item.minLeitura)
    return acc + consumoMedidor
  }, 0)
}

export const formatLeituraAtualExibicao = value => {
  const num = Number(value)
  if (!Number.isFinite(num)) return null

  const formatted = num.toFixed(0).padStart(7, "0")
  return {
    black: formatted.slice(0, -3),
    red: formatted.slice(-3),
  }
}
